import { faUserShield } from "@fortawesome/pro-regular-svg-icons/faUserShield";
import PropTypes from "prop-types";
import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import Card from "reactstrap/es/Card";
import Col from "reactstrap/es/Col";
import Row from "reactstrap/es/Row";

// App
import {
  ButtonAdd,
  ContentBody,
  ContentErrors,
  ContentHeader,
  ContentHeaderButtons,
  ContentHeaderTitle,
  Error403,
} from "../../core/components";
import { ROUTE_ROLE_ADD } from "../../../constants";

// Auth
import { usePermission } from "../../auth/hooks/usePermission";

// Role
import { gridChangeFilter, gridChangePagination, gridChangeSort, gridDelete, gridFetch } from "../actions/role";
import { RoleGrid } from "../components";

const RolePageList = (props) => {
  const { gridErrors } = props;
  const [hasPermission] = usePermission();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("title.roles");
  }, []);

  // Kontrola opravneni
  if (!hasPermission("role.view")) {
    return <Error403 />;
  }

  return (
    <Fragment>
      <ContentHeader>
        <ContentHeaderTitle icon={faUserShield} title={t("title.roles")} />
        <ContentHeaderButtons>
          {hasPermission("role.create") && <ButtonAdd text={t("action.add")} to={ROUTE_ROLE_ADD} />}
        </ContentHeaderButtons>
      </ContentHeader>

      <ContentErrors errors={gridErrors} />

      <ContentBody>
        <Row>
          <Col>
            <Card>
              <RoleGrid {...props} />
            </Card>
          </Col>
        </Row>
      </ContentBody>
    </Fragment>
  );
};

RolePageList.propTypes = {
  gridChangeFilter: PropTypes.func.isRequired,
  gridChangePagination: PropTypes.func.isRequired,
  gridChangeSort: PropTypes.func.isRequired,
  gridData: PropTypes.array.isRequired,
  gridDataTotal: PropTypes.number.isRequired,
  gridDelete: PropTypes.func.isRequired,
  gridErrors: PropTypes.array.isRequired,
  gridFetch: PropTypes.func.isRequired,
  gridIsDeleting: PropTypes.bool.isRequired,
  gridIsFetching: PropTypes.bool.isRequired,
  gridPage: PropTypes.number.isRequired,
  gridPageSize: PropTypes.number.isRequired,
  gridSortField: PropTypes.string.isRequired,
  gridSortOrder: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
  gridChangeFilter,
  gridChangePagination,
  gridChangeSort,
  gridDelete,
  gridFetch,
};

const mapStateToProps = (state) => ({
  gridData: state.role.gridData,
  gridDataTotal: state.role.gridDataTotal,
  gridErrors: state.role.gridErrors,
  gridIsDeleting: state.role.gridIsDeleting,
  gridIsFetching: state.role.gridIsFetching,
  gridPage: state.role.gridPage,
  gridPageSize: state.role.gridPageSize,
  gridSortField: state.role.gridSortField,
  gridSortOrder: state.role.gridSortOrder,
});

export default connect(mapStateToProps, mapDispatchToProps)(RolePageList);
